export default __webpack_public_path__ + "static/blob-36-2a04c930b4f6a3b2ea695fe6e1c87fc1.svg";